import { render, staticRenderFns } from "./CampaignAudience.vue?vue&type=template&id=2a4ff3ef&scoped=true&"
import script from "./CampaignAudience.vue?vue&type=script&lang=js&"
export * from "./CampaignAudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ff3ef",
  null
  
)

export default component.exports